import { Routes, Route } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from './components/theme/AppTheme';

import { dataGridCustomizations } from './components/theme/customizations/dataGrid.js';
// import CustomizedDataGrid from './components/dashboard/CustomizedDataGrid.js';

// USER CONTEXT
import PrivateRoute from './PrivateRoute';
import { UserProvider } from './context/UserContext';

// PAGES
import Login from './pages/Login';
import DashboardLayout from './pages/DashboardLayout';
import DashboardHome from './pages/DashboardHome';

import ManageCustomer from "./pages/ManageCustomer";
import ManageList from "./pages/ManageList";
import ManageOrders from './pages/ManageOrders';
import ManageArrived from './pages/ManageArrived';
import ManageInventory from './pages/ManageInventory';

import Settings from './pages/Settings.js';
import ManageUsers from './pages/ManageUsers.js';
import ManageCategories from './pages/ManageCategories.js';
import ManagePaymentMethods from './pages/ManagePaymentMethods.js';
import ManagePayment from './pages/ManagePayment.js';

import NetworkStatus from './utils/NetworkStatus.js';
import CopyText from './pages/CopyText.js';
import CopyPaymentSummary from './pages/CopyPaymentSummary.js';

const xThemeComponents = {
    // ...chartsCustomizations,
    ...dataGridCustomizations,
    // ...datePickersCustomizations,
    // ...treeViewCustomizations,
};

function App() {
    return (
        <AppTheme themeComponents={xThemeComponents}>

            <CssBaseline enableColorScheme />
            <NetworkStatus />

            <UserProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/copy-text/:token" element={<CopyText />} />
                    <Route path="/copy-image/:token" element={<CopyPaymentSummary />} />

                    <Route element={<PrivateRoute />}>
                        <Route element={<DashboardLayout />}>
                            <Route index element={<DashboardHome />} />
                            <Route path="customer" element={<ManageCustomer />} />
                            <Route path="order-list" element={<ManageList />} />
                            <Route path="manage-payment" element={<ManagePayment />} />
                            <Route path="manage-orders" element={<ManageOrders />} />
                            <Route path="manage-arrived" element={<ManageArrived />} />
                            <Route path="manage-inventory" element={<ManageInventory />} />
                            <Route path="settings" element={<Settings />} />

                            <Route path="users" element={<ManageUsers />} />
                            <Route path="categories" element={<ManageCategories />} />
                            <Route path="payment-methods" element={<ManagePaymentMethods />} />
                        </Route>
                    </Route>
                </Routes>
            </UserProvider>
        </AppTheme>
    );
}

export default App;